<template>
  <div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('addEditMoisComptable.information.title')}}</p>
      </header>
      <div class="card-content">
        <information-general
          :data="moisComptable"
          :detail="detail"/>
      </div>
    </div>
  </div>
</template>

<script>
import InformationGeneral from '@/components/presse/moisComptable/information/informationGeneral';

export default {
  name: 'MoisComptableInformation',
  props: {
    moisComptable: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
  },
  components: {
    InformationGeneral,
  },
};
</script>
